import PageHero from "@/components/feature/PageHero";
import Greeting from "./components/Greeting";
import Teachers from "./components/Teachers";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function About() {
  return (
    <>
      <PageHero
        tag="ABOUT"
        title={
          <>
            수학 한 길,
            <br />
            <span className="text-primary-500">18년의 전문성</span>
          </>
        }
        description="화려한 말 대신 성적으로 증명해 온 명불허전 수학학원의 이야기와 강사진을 소개합니다."
        image="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20composition%20with%20soft%20glowing%20lime%20green%20light%20orbs%20and%20abstract%20geometric%20forms%20over%20a%20deep%20charcoal%20background%2C%20soft%20volumetric%20light%2C%20minimal%20editorial%20poster%20art%2C%20cinematic%20depth%2C%20no%20text&width=1920&height=720&seq=mbhj-about-hero-01&orientation=landscape"
      />
      <Greeting />
      <Teachers />
      <ConsultCTA />
    </>
  );
}